// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/fronts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/fronts/fronts.js';

mount([g0]);
